// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardBlock } from 'reactstrap';

import { loadAllUsers } from 'actions/users';

type Props = {
  // redux
  uniques: number,
  signups: number,
  onLoadAllUsers: () => void,
};

class UserStats extends React.Component<Props> {
  componentDidMount() {
    const { onLoadAllUsers } = this.props;
    onLoadAllUsers();
  }

  render() {
    const { uniques, signups } = this.props;
    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Statistik</CardHeader>
        <CardBlock>
          <div>
            <strong>Anzahl Besucher: </strong>
            <span>{uniques}</span>
          </div>
          <div>
            <strong>Anzahl Anmeldungen: </strong>
            <span>{signups}</span>
          </div>
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const mapStateToProps = ({ users: { all: users } }) => {
  return {
    uniques: users.length,
    signups: users.filter(u => !!u.email).length,
  };
};
const mapDispatchToProps = dispatch => ({
  onLoadAllUsers: () => dispatch(loadAllUsers()),
});
const UserStatsContainer = connect(mapStateToProps, mapDispatchToProps)(
  UserStats
);

export default UserStatsContainer;



// WEBPACK FOOTER //
// ./src/components/UserStats/UserStats.js